import React from 'react';
import { Shield, Heart, CheckCircle, TrendingUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const VALUES = [
  { icon: Shield, bg: 'bg-amber-600', title: 'why_expertise_title', desc: 'why_expertise_desc' },
  { icon: Heart, bg: 'bg-emerald-700', title: 'why_care_title', desc: 'why_care_desc' },
  { icon: CheckCircle, bg: 'bg-amber-600', title: 'why_simple_title', desc: 'why_simple_desc' },
  { icon: TrendingUp, bg: 'bg-emerald-700', title: 'why_partnership_title', desc: 'why_partnership_desc' },
];

const WhyUsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="why-us" className="py-20 px-4 sm:px-6 lg:px-8 bg-emerald-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-600 to-emerald-900"></div>
      </div>
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">{t('why_us_title')}</h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">{t('why_us_subtitle')}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {VALUES.map(({ icon: Icon, bg, title, desc }) => (
            <div key={title} className="text-center p-6 hover:bg-white/5 rounded-lg transition-colors duration-300">
              <div className={`w-20 h-20 ${bg} rounded-full flex items-center justify-center mx-auto mb-6`}>
                <Icon className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3">{t(title)}</h3>
              <p className="text-slate-300">{t(desc)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
